import { RouteConfig } from 'vue-router'
import { customPageLinkRouteNames } from '@/routes/constants/location'

const CustomPagesLinkPage = () =>
  import(
    /* webpackChunkName: "custom-menu-link" */ '@/pmd/pages/agency/CustomPagesLinkPage.vue'
  )

export const customPageLinkRoute: RouteConfig[] = [
  {
    path: 'custom-page-link/:id',
    name: customPageLinkRouteNames.default,
    component: CustomPagesLinkPage,
  },
]
